var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"subtitle is-1 is-size-2-touch has-text-centered is-300 has-text-black mt-6 mb-0"},[_vm._v(" mirá las "),_c('span',{staticClass:"is-700"},[_vm._v("transmisiones pasadas")])])])])
}]

export { render, staticRenderFns }